export default __webpack_public_path__ + "static/media/Microsoft-Office-01.c050be38.svg";